import { useNavigate, useLocation } from "react-router-dom";

function useRemoveFilterParams() {
  const navigate = useNavigate();
  const location = useLocation();

  const removeFilterParams = () => {
    const searchParams = new URLSearchParams(location.search);
    const updatedParams = [];

    // Keep only non-filter[...] params
    for (const [key, value] of searchParams.entries()) {
      if (!/^filter\[[^\]]+\]$/.test(key)) {
        updatedParams.push(`${key}=${value}`);
      }
    }

    const newSearch = updatedParams.length > 0 ? `?${updatedParams.join("&")}` : "";

    navigate({
      pathname: location.pathname,
      search: newSearch,
    });
  };

  return { removeFilterParams };
}

export default useRemoveFilterParams;
